import Swal from 'sweetalert2'
const Alerts = {
  swal: (type, title, text, onClose) => {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
      timer: 6000,
      confirmButtonText: 'Entendi',
      confirmButtonColor: '#DA5A34',
    }).then(result => {
      if (onClose) if (result.isConfirmed || result.isDismissed || result.isDenied) onClose()
    })
  },

  question: async (title, text, func) => {
    return Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#bf3324',
      cancelButtonColor: '#00cda4',
      confirmButtonText: 'Não',
      cancelButtonText: 'Sim',
    }).then(async result => {
      if (!result.isConfirmed && result.dismiss === 'cancel') {
        await func()
      }
    })
  },
}

export default Alerts
